import script from "./CommunityIcons.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommunityIcons.vue?vue&type=script&setup=true&lang=ts"

import "./CommunityIcons.vue?vue&type=style&index=0&id=13100846&scoped=true&lang=scss"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13100846"]])

export default __exports__